<template>
  <div class="bg_pupop">
    <div class="pupop_form">
      <el-form
        ref="form"
        :rules="rules"
        :model="form"
        label-width="155px"
        label-position="right"
        :disabled="formDisbled"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="报告人:">
              <el-input placeholder="请输入报告人" type="text" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="所属企业:">
              <el-input placeholder="请输入所属企业" type="text" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="报告类型:">
              <el-select
                v-model="value"
                placeholder="请选择"
              >
                <el-option label="丢失/被盗/被抢" value="丢失/被盗/被抢" />
                <el-option label="运行状态的变更" value="运行状态的变更" />
                <el-option label="可疑情况报告" value="可疑情况报告" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="所属企业:">
              <el-input type="textarea" :rows="8" />
            </el-form-item>
          </el-col>、
        </el-row>
        <el-row :gutter="20" class="upload_file">
          <el-col :span="24">
            <el-upload
              class="avatar-uploader"
              action="https://jsonplaceholder.typicode.com/posts/"
              :on-change="handleChange"
              :file-list="fileList"
            >

              <el-button class="upload_button" size="small" icon="el-icon-paperclip" plain type="primary">点击上传</el-button>
            </el-upload>
          </el-col>
        </el-row>
      </el-form>
      <div class="tips">
        <el-checkbox v-model="radioChecked" :disabled="formDisbled" class="radio" />
        <p>我已阅读《 <span>报告投诉须知</span> 》</p>

      </div>
      <div style="text-align: center">
        <el-button
          v-preventReClick
          type="primary"
          style="background: #4170ff"
          @click="saveForm"
        >确定</el-button>
        <el-button
          @click="closeDia"
        >取消</el-button>
      </div>

    </div>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    currentValue: Object,
    formRow: Object
  },
  data() {
    return {
      radioChecked: false,
      formDisbled: false,
      value: '',
      fileList: [],
      form: {},
      rules: {}
    }
  },
  computed: {},
  watch: {},

  mounted() {
    // formRow 父组件点击当前行数据
    this.form = this.formRow
    // currentValue 当前的操作 2为查看 1为新增
    if (this.currentValue.value === 2) {
      this.formDisbled = true
    }
  },
  methods: {
    /**
     * 是否选中报告投诉须知
     */
    radioClick() {
      this.radioChecked = !this.radioChecked
    },
    saveForm() {
      this.$refs['form'].validate((valid) => {
        if (valid) {

        }
      })
    },
    handleChange(file, fileList) {
      this.fileList = fileList.slice(-3)
    },

    /**
     * 关闭dialog
     */
    closeDia() {
      this.$emit('listenClose')
    }
  }
}
</script>
<style lang="less" scoped>
.bg_pupop {
  .pupop_form {
    .el-form div:nth-child(3),
    .el-form div:nth-child(2) {
      .el-form-item__content {
        .el-select {
          width: 100%;
          .el-input {
            .el-input__inner {
              width: 100%;
            }
          }
        }
      }
    }
  }
}
.tips{
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: center;
    margin: 20px 0;
    .radio{
        margin-right: 10px;
        /deep/ .el-checkbox__inner{
            border-radius: 50%;
        }
    }
    p{
        span{
            color: #409EFF;
            cursor: pointer;
        }
    }
}
.upload_file{
    margin-top: -20px;
    .avatar-uploader{
        float: right;
        text-align: right;
        .upload_button{
            border-radius: 30px;
            padding: 6px 15px;
            color: #333;
        }
    }
}

</style>
